module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAOCAYAAAGz9LdlAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARxJREFUeNpiYMAFAAKI4f///wbInP8wNkAAgTgF/yHgPIoEsmpkCYAAAuvAogiuMgCI9yNJWLIAaUMgPg+lYcAI7jSozgIoXwoggJBd9R8qCHLdexx+E8PqUiBzPbJbkMRTkTkJ/zGBAZoGO4AAgjEaGIgBSCadR+Jj1cyExEa29gNQgwI2xY1Q9gYQwQgEQEoAiBNwOeU9WvgGEOt2GHhPSMN5ZNXo8gABBlM0H9lEIBZAkgMlGgdkMSJDmYMJGqzIngcZArIAJqYAFSvAFw1YgBzIBgUs4TEfPW9BfQSy4D4xFgDV+OEMP/QMBnUEHBNheBUDFheig/XIuQyUUYgJf6CaEJxFDFJawwUaCBiuTch2AZAhhOIEh15uAKuqxS46UWj8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneIcon/phone_equipment.png
// module id = ytcm
// module chunks = 4